import './style.scss';
import { useSelector } from 'react-redux';
import { formatNumber } from 'utils';

export const TotalStaked: React.FC<{}> = () => {
  const { isLoggedIn } = useSelector<any, any>(({ profile }) => profile);
  const { allPoolInfo } = useSelector<any, any>(({ allPoolInfoSlice }) => allPoolInfoSlice);

  return (
    <div className='flex flex-col items-center md:items-start p-6 rounded-2xl border-[#33363D] border-[1px] bg-[#141416]'>
      <img className='mb-5 w-12 h-12 object-contain' src={require('assets/icons/logo-ember-invert-transparent.png')} alt='Ember logo' />
      <div className='title text-[#A2A2AF] mb-2'>Total staked across all pools</div>
      <div className='font-bold text-white text-xl leading-8'>
        {isLoggedIn ? `${formatNumber(Math.round(allPoolInfo?.amount ?? 0), '', 3)} SPO` : '-'}
      </div>
    </div>
  );
};
